<template>
  <div class="expandable-value">
    <!-- JSON content -->
    <template v-if="isJSONValue">
      <snippet v-if="isExpanded || !isTruncated" :code="value" language="json" />
      <template v-else>
        <snippet :code="truncatedValue" language="json" />
        <button class="button is-small is-text expand-button" @click="expand">
          <span>{{ $t('search.expandValue') }}</span>
        </button>
      </template>
    </template>
    
    <!-- Plain text content -->
    <template v-else>
      <p v-if="isExpanded || !isTruncated" class="value-text">{{ value }}</p>
      <template v-else>
        <p class="value-text">{{ truncatedValue }}</p>
        <button class="button is-small is-text expand-button" @click="expand">
          <span>{{ $t('search.expandValue') }}</span>
        </button>
      </template>
    </template>
    
    <!-- Collapse button when expanded -->
    <button 
      v-if="isExpanded && isTruncated" 
      class="button is-small is-text collapse-button" 
      @click="collapse"
    >
      <span>{{ $t('search.collapseValue') }}</span>
    </button>
  </div>
</template>

<script>
import { Snippet } from '@cyradar/ui'
import { isJSON } from '@/utils'

export default {
  name: 'ExpandableValue',
  components: {
    Snippet
  },
  props: {
    /**
     * The value to display
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Maximum length before truncation
     */
    maxLength: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      isExpanded: false
    }
  },
  computed: {
    /**
     * Check if value is JSON
     */
    isJSONValue() {
      return isJSON(this.value)
    },
    /**
     * Check if value needs truncation
     */
    isTruncated() {
      return this.value && this.value.length > this.maxLength
    },
    /**
     * Get truncated value with ellipsis
     */
    truncatedValue() {
      if (!this.isTruncated) {
        return this.value
      }
      return this.value.substring(0, this.maxLength) + '...'
    }
  },
  methods: {
    /**
     * Expand to show full value
     */
    expand() {
      this.isExpanded = true
    },
    /**
     * Collapse to show truncated value
     */
    collapse() {
      this.isExpanded = false
    }
  }
}
</script>

<style scoped>
.expandable-value {
  position: relative;
}

.value-text {
  word-break: break-word;
  white-space: pre-wrap;
  margin-bottom: 0;
}

.expand-button,
.collapse-button {
  margin-top: 0.5rem;
  padding: 0.25rem 0.5rem;
  height: auto;
  font-size: 0.85rem;
  color: #3273dc;
  text-decoration: underline;
}

.expand-button:hover,
.collapse-button:hover {
  color: #205bbc;
  background-color: transparent;
}

/* Dark theme support */
.theme-dark .expand-button,
.theme-dark .collapse-button {
  color: #7eb8ff;
}

.theme-dark .expand-button:hover,
.theme-dark .collapse-button:hover {
  color: #a8d4ff;
}
</style>
